"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSummaryResults = exports.questions = void 0;

var _screeners = require("../../screeners");

var _utils = require("../../screeners/utils");

var questions = (0, _screeners.expandscreeners)([{
  prompt: "Can you start by choosing the values that are most important to you right now? You can choose more than one and after I’ll ask you the focusing question for each one.",
  type: "triggerMulti",
  meta: {
    answerLabel: "My values are",
    summaryTitle: "Your important value was…"
  },
  options: ["Self-care", "Attitude / Personal Growth", "Career / Education", "Citizenship or Giving Back", "Finances", "Health / Wellbeing", "Family", "Friendships / Relationships", "Spirituality / Ethics", "Creativity", "Other"],
  batteryId: "VALUES_FOCUS"
}, {
  trigger: "Self-care",
  prompt: "Given that you chose self-care as a value, what is the ONE thing you can do, such that by doing it everything else will be easier or unnecessary?",
  type: "triggerTextAreaFollowUp",
  meta: {
    answerLabel: "My action will be",
    summaryTitle: "Your action for Self-care was…",
    placeholder: ""
  },
  options: ["Wake up early and do something for myself", "Arrange for some time to myself", "Book myself in for a massage or a health treatment", "Other"],
  batteryId: "VALUES_FOCUS"
}, {
  trigger: "Attitude / Personal Growth",
  prompt: "Given that you chose attitude/personal growth as a value, what is the one thing you can do, such that by doing it everything else will be easier or unnecessary?",
  type: "triggerTextAreaFollowUp",
  meta: {
    answerLabel: "My action will be",
    summaryTitle: "Your action for Attitude / Personal Growth was…",
    placeholder: ""
  },
  batteryId: "VALUES_FOCUS"
}, {
  trigger: "Career / Education",
  prompt: "Given that you chose career/education as a value, what is the one thing you can do, such that by doing it everything else will be easier or unnecessary?",
  type: "triggerTextAreaFollowUp",
  meta: {
    summaryTitle: "Your action for Career / Education was…",
    placeholder: ""
  },
  batteryId: "VALUES_FOCUS"
}, {
  trigger: "Citizenship or Giving Back",
  prompt: "Given that you chose citizenship/giving back as a value, what is the one thing you can do, such that by doing it everything else will be easier or unnecessary?",
  type: "triggerTextAreaFollowUp",
  meta: {
    answerLabel: "My action will be",
    summaryTitle: "Your action for Citizenship or Giving Back was…",
    placeholder: ""
  },
  batteryId: "VALUES_FOCUS"
}, {
  trigger: "Finances",
  prompt: "Given that you chose finances as a value, what is the one thing you can do, such that by doing it everything else will be easier or unnecessary?",
  type: "triggerTextAreaFollowUp",
  meta: {
    answerLabel: "My action will be",
    summaryTitle: "Your action for Finances was…",
    placeholder: ""
  },
  batteryId: "VALUES_FOCUS"
}, {
  trigger: "Health / Wellbeing",
  prompt: "Given that you chose health/wellbeing as a value, what is the one thing you can do, such that by doing it everything else will be easier or unnecessary?",
  type: "triggerTextAreaFollowUp",
  meta: {
    answerLabel: "My action will be",
    summaryTitle: "Your action for Health / Wellbeing was…",
    placeholder: ""
  },
  batteryId: "VALUES_FOCUS"
}, {
  trigger: "Spirituality / Ethics",
  prompt: "Given that you chose spirituality/ethics as a value, what is the one thing you can do, such that by doing it everything else will be easier or unnecessary?",
  type: "triggerTextAreaFollowUp",
  meta: {
    answerLabel: "My action will be",
    summaryTitle: "Your action for Spirituality / Ethics was…",
    placeholder: ""
  },
  batteryId: "VALUES_FOCUS"
}, {
  trigger: "Family",
  prompt: "Given that you chose family as a value, what is the one thing you can do, such that by doing it everything else will be easier or unnecessary?",
  type: "triggerTextAreaFollowUp",
  meta: {
    answerLabel: "My action will be",
    summaryTitle: "Your action for Family was…",
    placeholder: ""
  },
  batteryId: "VALUES_FOCUS"
}, {
  trigger: "Friendships / Relationships",
  prompt: "Given that you chose friendships/relationships as a value, what is the one thing you can do, such that by doing it everything else will be easier or unnecessary?",
  type: "triggerTextAreaFollowUp",
  meta: {
    answerLabel: "My action will be",
    summaryTitle: "Your action for Friendships / Relationships was…",
    placeholder: ""
  },
  batteryId: "VALUES_FOCUS"
}, {
  trigger: "Creativity",
  prompt: "Given that you chose creativity growth as a value, what is the one thing you can do, such that by doing it everything else will be easier or unnecessary?",
  type: "triggerTextAreaFollowUp",
  meta: {
    answerLabel: "My action will be",
    summaryTitle: "Your action for Creativity was…",
    placeholder: ""
  },
  batteryId: "VALUES_FOCUS"
}, {
  trigger: "Other",
  prompt: "Given that you chose other as a value, what is one thing that you could do this week that would be an action based on this value?",
  type: "textarea",
  meta: {
    answerLabel: "My action will be",
    summaryTitle: "Your action for Other was…",
    placeholder: ""
  },
  batteryId: "VALUES_FOCUS"
}, _utils.screeners.HELPFUL]);
exports.questions = questions;

var getSummaryResults = function getSummaryResults(answers) {
  var summaryItems = [];
  answers["VALUES_FOCUS"][0].forEach(function (value, index) {
    summaryItems.push({
      question: questions[0],
      answer: value
    });
    questions.forEach(function (question, questionIndex) {
      if (question.trigger === value) {
        summaryItems.push({
          question: question,
          answer: answers["VALUES_FOCUS"][questionIndex]
        });
      }
    });
  });
  return summaryItems;
};

exports.getSummaryResults = getSummaryResults;